'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _map = require('./map.component');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapModule = _angular2.default.module('map', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.detail.map', {
    url: '/map',
    component: 'map',
    params: {
      item: null
    }
  });
}).component('map', _map2.default).name;

exports.default = mapModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/map/map.js